import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import LoginButton from '../../buttons/LoginButton'
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { logInRes, logInTodo } from '../../../redux/Slices/LoginSlice/Login'
import { BussinessAreaTodo } from '../../../redux/Slices/LoginSlice/BussinessArea'
import { AiOutlineMail, AiOutlineSelect } from "react-icons/ai";
import { RiLockPasswordLine } from "react-icons/ri";
import { LogInSchema } from './Validation';
import Select from 'react-select'


export default function LoginForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [spiner, setSpiner] = useState(false)
    const BussinessAreaList = useSelector(state => state?.BussinessArea?.data?.data)



    useEffect(() => {
        dispatch(BussinessAreaTodo())
    }, [])

    const handleBusinessAreaChange = (e) => {
        const selectedOption = e.target.selectedOptions[0]; // Get the selected option element

        const businessAreaName = selectedOption.getAttribute('data-name')
        const businessAreaId = selectedOption.getAttribute('data-business_area_id')
        const businessAreaShortName = selectedOption.getAttribute('data-shortname');
        const allowVatSales = selectedOption.getAttribute('data-vatsales');


    };

    const initiaValues = {
        username: '',
        password: '',
      
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: LogInSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(logInTodo(values)).then(() => loginInFun())
        }
    })

    const loginInFun = () => {
        if (logInRes && logInRes.status) {
            localStorage.setItem('vcust_plant_code', logInRes?.data[0]?.vcust_plant_code)
            localStorage.setItem('vplant_name', logInRes?.data[0]?.vplant_name)
            localStorage.setItem('icurrency_id', logInRes?.data[0]?.icurrency_id)
            localStorage.setItem('cshare_allowed', logInRes?.data[0]?.cshare_allowed)
            localStorage.setItem('idespatch_city', logInRes?.data[0]?.idespatch_city)
            localStorage.setItem('vdespatach_gst_no', logInRes?.data[0]?.vcust_des_gst_no)
            localStorage.setItem('vdespatach_pincode', logInRes?.data[0]?.vcust_des_pin)
            localStorage.setItem('vship_to_address', logInRes?.data[0]?.vship_to_address)
            localStorage.setItem('istate_id', logInRes?.data[0]?.istate_id)
            localStorage.setItem('icompany_state_id', logInRes?.data[0]?.icompany_state_id)
            localStorage.setItem('vship_to_state', logInRes?.data[0]?.vship_to_state)
            localStorage.setItem('icity_id', logInRes?.data[0]?.icity_id)
            localStorage.setItem('vcustomer_plant_city', logInRes?.data[0]?.vcustomer_plant_city)
            localStorage.setItem('vcustomer_plant_address', logInRes?.data[0]?.vcustomer_plant_address)
            localStorage.setItem('icurrency_id', logInRes?.data[0]?.icurrency_id)
            localStorage.setItem('cTax_type', logInRes?.data[0]?.ctax_type)
            localStorage.setItem('icustomer_type_id', logInRes?.data[0]?.icustomer_type_id)
            localStorage.setItem('csale_type', logInRes?.data[0]?.csale_type)
            localStorage.setItem('vfin_year', logInRes?.vfin_year)
            localStorage.setItem('dyear_start_date', logInRes?.dyear_start_date)
            localStorage.setItem('vuser_name', logInRes?.vuser_name)
            localStorage.setItem('dyear_end_date', logInRes?.dyear_end_date)
            localStorage.setItem('fcredit_limit', logInRes?.data[0]?.fcredit_limit)
            localStorage.setItem('fopening_balance', logInRes?.data[0]?.fopening_balance)

            localStorage.setItem('vbusiness_area_short_name', 'H');
            localStorage.setItem('ibusiness_area_id', 1);
            localStorage.setItem('allowVatSales', 'Y');
            localStorage.setItem('businessAreaName', 'HO');


            setSpiner(false);
            navigate('/dashboard')
        } else {
            setSpiner(false);
            toast.error(logInRes && logInRes.message, { position: "bottom-right" });
        }
    }
    return (
        <>
            <div className='mt-3'>
                <Form onSubmit={handleSubmit}>

                    <div className="input-group  input_section" style={{ position: 'relative' }}>
                        <span className='input_icon'> <AiOutlineMail className='mb-1 me-2 ' style={{ color: "#105684" }} size={20} /></span>
                        <input type="text" className="form-control form-login-input login_placeholder "
                            placeholder="Username"
                            name='username'
                            value={values.username}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                    {errors.username && touched.username ? (<span className='text-danger text-start' >{errors.username}</span>) : null}


                    <div className="input-group mt-3 input_section" style={{ position: 'relative' }}>
                        <span className='input_icon'> <RiLockPasswordLine style={{ color: "#105684" }} className='mb-1 me-2' size={20} /></span>
                        <input type="password" className="form-control form-login-input "
                            placeholder="Password"
                            name='password'
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </div>
                    {errors.password && touched.password ? (<span className='text-danger text-start' >{errors.password}</span>) : null}

                    {/* <div className="input-group mt-3 input_section" style={{ position: 'relative' }}>
                        <span className='input_icon'> <AiOutlineSelect style={{ color: "#105684" }} className='mb-1 me-2' size={20} /></span>
                        <Form.Select aria-label="Default select example" className='form-login-input'
                            name='bussiness_id'
                            value={values.bussiness_id}
                            onChange={(e) => { handleChange(e); handleBusinessAreaChange(e); }}
                            onBlur={handleBlur}
                        >
                            <option>Select Bussiness Area</option>
                            {BussinessAreaList?.map((val, index) =>
                                <option
                                    key={index}
                                    value={val?.ibusiness_area_id}
                                    data-business_area_id={val?.ibusiness_area_id}
                                    data-shortname={val?.vshort_name}  // Storing extra data in option attributes
                                    data-name={val?.vbusiness_area_name}  // Storing extra data in option attributes
                                    data-vatsales={val?.callow_vat_sales}
                                >
                                    {val?.vbusiness_area_name}
                                </option>
                            )}

                        </Form.Select>

                    </div>
                    {errors.bussiness_id && touched.bussiness_id ? (<span className='text-danger text-start' >{errors.bussiness_id}</span>) : null} */}
                    <div className='mt-4 d-flex justify-content-center'>
                        <LoginButton name={'Login'} spiner={spiner} />
                    </div>
                </Form>
            </div>
            <ToastContainer />
        </>
    )
}
